import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import DrawerRequisites from "../Drawer/Requisites"; // Подробная информация по Заказчику

const Customer = ({ form, disabled }) => {
  const [showRequisites, setShowRequisites] = useState({
    drawer: false,
    visible: false
  });
  const { getFieldDecorator, getFieldValue } = form;
  const company = getFieldValue("companyId");
  const subject = getFieldValue("subject");
  const handleShowRequisites = () => {
    setShowRequisites({ drawer: true, visible: true });
  };
  const handleCloseDrawer = () => {
    setShowRequisites({ drawer: true, visible: false });
  };
  return (
    <>
      {subject === "physical" ? (
        <div className="offer-card__item double-margin">
          <span className="label">Заказчик:</span>
          <Form.Item>
            {getFieldDecorator("customer")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("subject")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("name")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("lastname")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("patronymic")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>

          {company && (
            <span className="extra-label">
              <span className="show-map">
                <Button type="primary" ghost onClick={handleShowRequisites}>
                  Подробнее
                </Button>
              </span>
            </span>
          )}
          {showRequisites.drawer && (
            <DrawerRequisites
              visible={showRequisites.visible}
              handleClose={handleCloseDrawer}
              form={form}
            />
          )}
        </div>
      ) : (
        <div className="offer-card__item double-margin">
          <span className="label">Заказчик:</span>
          <Form.Item>
            {getFieldDecorator("customer")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("nameLegal")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("subject")(
              <Input style={{ width: 368 }} disabled={disabled} />
            )}
          </Form.Item>

          {company && (
            <span className="extra-label">
              <span className="show-map">
                <Button type="primary" ghost onClick={handleShowRequisites}>
                  Подробнее
                </Button>
              </span>
            </span>
          )}
          {showRequisites.drawer && (
            <DrawerRequisites
              visible={showRequisites.visible}
              handleClose={handleCloseDrawer}
              form={form}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Customer;
